import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import SummaryApi from "../common";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

   const submit = async () => {
    if (!password || !confirmPassword) {
      toast.error("All fields are required");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        `${SummaryApi.resetPassword.url}/${token}`,
        { password }
      );

      toast.success("Password updated successfully");
      navigate("/login");

    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Reset password failed"
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="mt-8 mb-4 p-6 max-w-sm mx-auto bg-white shadow rounded">
      <h2 className="text-xl font-bold text-center mb-4">Reset Password</h2>

 {/* New Password */}
      <div className="mb-3">
        <label className="text-sm font-medium">New Password</label>
        <div className="border p-2 flex items-center rounded">
          <input
            type={showPassword ? "text" : "password"}
            className="w-full outline-none"
            placeholder="Enter new password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span
            className="cursor-pointer text-xl text-gray-600"
            onClick={() => setShowPassword(prev => !prev)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
      </div>

      {/* Confirm Password */}
      <div className="mb-3">
        <label className="text-sm font-medium">Confirm Password</label>
        <div className="border p-2 flex items-center rounded">
          <input
            type={showConfirmPassword ? "text" : "password"}
            className="w-full outline-none"
            placeholder="Confirm password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <span
            className="cursor-pointer text-xl text-gray-600"
            onClick={() => setShowConfirmPassword(prev => !prev)}
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
      </div>

      <button
        className="bg-green-600 text-white px-4 py-2 mt-3 mb-3 w-full rounded disabled:opacity-60"
        onClick={submit}
        disabled={loading}
      >
        {loading ? "Updating..." : "Update Password"}
      </button>
    </div>
  );
}